import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  AdminCompanyListItem,
  AdminPagination,
} from "../../../domain/administrator/model";

type CompaniesState = AdminPagination<AdminCompanyListItem> & {
  loading: boolean;
};

const initialState: CompaniesState = {
  loading: false,
  docs: [],
  totalDocs: 0,
  limit: 0,
  totalPages: 0,
  page: 0,
  pagingCounter: 0,
  hasPrevPage: false,
  hasNextPage: false,
  prevPage: null,
  nextPage: null,
};

const dataSlice = createSlice({
  name: "load-companies",
  initialState: initialState,
  reducers: {
    eraseCompaniesStore: () => {
      return { ...initialState };
    },
    setCompaniesLoading: (state) => {
      state.loading = true;
    },
    setCompaniesResults: (
      state,
      action: PayloadAction<AdminPagination<AdminCompanyListItem>>,
    ) => {
      state.loading = false;
      state.docs = action.payload.docs;
      state.totalDocs = action.payload.totalDocs;
      state.limit = action.payload.limit;
      state.totalPages = action.payload.totalPages;
      state.page = action.payload.page;
      state.pagingCounter = action.payload.pagingCounter;
      state.hasPrevPage = action.payload.hasPrevPage;
      state.hasNextPage = action.payload.hasNextPage;
      state.prevPage = action.payload.prevPage;
      state.nextPage = action.payload.nextPage;
    },
    setCompaniesFailure: (state) => {
      state.loading = false;
    },
  },
});

export const {
  eraseCompaniesStore,
  setCompaniesFailure,
  setCompaniesLoading,
  setCompaniesResults,
} = dataSlice.actions;

export default dataSlice.reducer;
